export async function chooseLocation({ location }) {
    try {
        const url = routes['app_googlemybusiness_chooselocation'];

        showPreloader();

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ account_and_location: location }),
        });

        const json = await response.json();

        return { isSuccess: json.status, message: json.message };
    } catch (error) {
        console.error(error);

        return { isSuccess: false };
    } finally {
        hidePreloader();
    }
}

export async function disconnect() {
    try {
        const url = routes['app_googlemybusiness_disconnect'];

        showPreloader();

        const response = await fetch(url, {
            method: 'POST',
        });

        const json = await response.json();

        return { isSuccess: json.status, message: json.message };
    } catch (error) {
        console.error(error);

        return { isSuccess: false };
    } finally {
        hidePreloader();
    }
}
